// src/features/landing/presentation/pages/TermsPage.jsx
// 개인정보처리방침(/privacy)·이용약관(/terms) 전용 페이지 — 회원가입·신청 화면 모달과 같은 terms 테이블 활성 버전을 보여준다
// (GET /api/terms/{PRIVACY|SERVICE}). RB Bridge 정적 랜딩(/bridge/mna) 푸터 링크의 연결 대상.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Footer } from "../components/Footer";
import { termsRepository } from "../../infrastructure/termsApiRepository";

const TERMS_PAGES = {
    PRIVACY: { title: "개인정보처리방침", path: "/privacy" },
    SERVICE: { title: "서비스 이용약관", path: "/terms" },
};

export function TermsPage({ type }) {
    const page = TERMS_PAGES[type];
    const [terms, setTerms] = useState(null);
    const [status, setStatus] = useState("loading"); // loading | done | error

    useEffect(() => {
        let ignore = false;
        setStatus("loading");
        termsRepository.getTermsByType(type)
            .then((data) => {
                if (ignore) return;
                setTerms(data);
                setStatus("done");
            })
            .catch(() => {
                if (!ignore) setStatus("error");
            });
        return () => { ignore = true; };
    }, [type]);

    useEffect(() => {
        document.title = `${page.title} | 라이징브로커즈`;
    }, [page.title]);

    return (
        <>
            <main className="terms">
                <div className="terms-container">
                    <nav className="terms-tabs" aria-label="약관">
                        {Object.entries(TERMS_PAGES).map(([key, p]) => (
                            <Link key={key} to={p.path} className={`terms-tab${key === type ? " terms-tab--on" : ""}`}>
                                {p.title}
                            </Link>
                        ))}
                    </nav>

                    <h1 className="terms-title">{terms?.title || page.title}</h1>
                    {status === "done" && (terms.version || terms.updatedAt) && (
                        <p className="terms-meta">
                            {terms.version && <>버전 {terms.version}</>}
                            {terms.version && terms.updatedAt && " · "}
                            {terms.updatedAt && <>최종 수정 {terms.updatedAt.slice(0, 10)}</>}
                        </p>
                    )}

                    <div className="terms-body">
                        {status === "loading" && <p className="terms-note">{page.title}을 불러오는 중입니다.</p>}
                        {status === "error" && (
                            <p className="terms-note">
                                {page.title}을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.
                                <br />
                                문의: <a href="tel:02-858-2014">02-858-2014</a>
                            </p>
                        )}
                        {status === "done" && terms.content.split("\n").map((line, i) => <p key={i}>{line || <br />}</p>)}
                    </div>
                </div>
            </main>
            <Footer />

            <style>{`
                .terms { background: #fff; color: #1c1814; text-align: left; word-break: keep-all; padding: 48px 0 96px; }
                .terms-container { max-width: 800px; margin: 0 auto; padding: 0 40px; }
                .terms-tabs { display: flex; gap: 28px; border-bottom: 1px solid #e5ddd7; margin-bottom: 40px; }
                .terms-tab {
                    padding: 0 0 14px; margin-bottom: -1px; font-size: 15px; font-weight: 700; color: #8a8079;
                    text-decoration: none; border-bottom: 3px solid transparent;
                }
                .terms-tab:hover { color: #1c1814; }
                .terms-tab--on { color: #1c1814; border-bottom-color: #f16102; }
                .terms-title { margin: 0; font-size: clamp(26px, 3vw, 34px); font-weight: 800; letter-spacing: -0.02em; }
                .terms-meta { margin: 10px 0 0; font-size: 13px; color: #8a8079; }
                .terms-body { margin-top: 32px; font-size: 15px; line-height: 1.8; color: #4a433d; }
                .terms-body p { margin: 0; }
                .terms-note { color: #8a8079; }
                .terms-note a { color: #f16102; }
                @media (max-width: 768px) {
                    .terms { padding: 32px 0 64px; }
                    .terms-container { padding: 0 16px; }
                    .terms-tabs { margin-bottom: 28px; }
                }
            `}</style>
        </>
    );
}
